import { useEffect, useRef, useState } from 'react'
import { Button, Flex, Text, rem } from '@mantine/core'
import ImageObserved from '../pipeline/Image'
import { PipelineParameters } from '../pipeline/Pipeline'
import { NOTIFICATION_SERVICE } from '../../../components/notifications/NotificationService'
// import { UploadCarPerspectiveButton } from '../pipeline/UploadCarPerspectiveButton'
import CanvasDraw from "react-canvas-draw";
import { useStore } from '../../../hooks/use-store'
import { observer } from 'mobx-react'
import { useRequest } from 'ahooks'

function FillCar(model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) {

  const {
    dataStore: { spaceStore, appStore },
  } = useStore();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading: runAsyncConvertBase64Loading, runAsync: runAsyncConvertBase64 } = useRequest(
    async (model: { url: string }) => appStore.convertImageBase64({
      url: model.url,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          return res.url
        }
      },
    }
  );

  useEffect(() => {
    if (spaceStore.selectedImage) {
      const img = new Image();
      img.onload = function () {
        // max width 1200
        // max height 1200 
        // with ratio
        const width = img.width
        const height = img.height
        const ratio = width / height
        if (width > height) {
          setWidth(1200)
          setHeight(1200 / ratio)
        }
        if (height > width) {
          setHeight(1200)
          setWidth(1200 * ratio)
        }
        if (width === height) {
          setWidth(1200)
          setHeight(1200)
        }
      }
      console.log(spaceStore.selectedImage)
      setBackground(spaceStore.selectedImage)
      img.src = spaceStore.selectedImage
    }
  }, [spaceStore.selectedImage])

  const renderRef = useRef<CanvasDraw>(null);
  const [width, setWidth] = useState(1000)
  const [height, setHeight] = useState(1000)
  const [background, setBackground] = useState('')
  // const [prompt, setPrompt] = useState('')
  return (
    <Flex w={'100%'} mt={12} pt={16} pb={16} pl={20} pr={20} style={{ borderRadius: '4px', background: 'rgba(32, 32, 32, 1)'  }} gap={32}>

      <Flex direction={'column'} miw={'300px'} w={'100%'} gap={12}>
        <Text fz={20}>Add car workflow</Text>
        <Text fz={12}>select the car area with brush</Text>
        {
          background ? <Flex
            w={width + 'px'}
            h={height + 'px'}
            style={{
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'relative',
                zIndex: 1,
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.2)',
              }}

            >
              <CanvasDraw
                ref={renderRef}
                backgroundColor='#00000028'
                lazyRadius={0}
                hideGrid={true}
                brushRadius={30}
                brushColor={'#ffff'}
                canvasWidth={width}
                canvasHeight={height}
              />
            </div>
            <ImageObserved
              style={{
                background: '#2424263f',
                position: 'absolute',
                borderRadius: '4px',
                left: 0,
                padding: 0,
              }}
              width={width + 'px'}
              height={height + 'px'}
              dark
              objectFit='cover'
              src={background}
            />

          </Flex> : null
        }

        {/* <Textarea
          w="100%"
          minRows={7}
          size="sm"
          label="Area to remove"
          value={prompt}
          description=""
          placeholder="Snow road"
          onChange={(e) => {
            console.log(e)
            setPrompt(e.currentTarget.value)
          }}
        /> */}
        {/* <UploadCarPerspectiveButton
          text="Image"
          onSetImage={(image) => {
            const img = new Image();
            img.onload = function () {
              // max width 1200
              // max height 1200 
              // with ratio
              const width = img.width
              const height = img.height
              const ratio = width / height
              if (width > height) {
                setWidth(1200)
                setHeight(1200 / ratio)
              }
              if (height > width) {
                setHeight(1200)
                setWidth(1200 * ratio)
              }
              if (width === height) {
                setWidth(1200)
                setHeight(1200)
              }
            }
            console.log(image)
            setBackground(image)
            img.src = image
          }}
        /> */}

        <Flex gap={12} mt={32}  justify={'center'}>
          <Button
            styles={{
              root: {
                color: 'rgba(230, 230, 230, 1)',
                height: rem(36),

                fontSize: '14px',
                background: `#f53c02 !important`,
                border: 'none',
                position: 'relative',
              }
            }}
            variant="default"
            onClick={async () => {

              if (renderRef) {
                const image = renderRef.current?.getDataURL('image/png', false, '#000')
                const { url } = await runAsyncConvertBase64({ url: image })
                console.log(url)

                // NEW
                const pipeline: PipelineParameters = {
                  provider: 'custom',
                  type: 'fillCar',
                  prompt: '',
                  inputSrc: background,
                  maskSrc: url,
                  credits: 10,
                  srcset: [],
                }
                await model.buy([pipeline]);

              }
            }}
          >
            Run
          </Button>
        </Flex>
      </Flex>

    </Flex>
  )
}

export default observer(FillCar);